import { render } from "./Super.vue?vue&type=template&id=1edece38&scoped=true"
import script from "./Super.vue?vue&type=script&lang=js"
export * from "./Super.vue?vue&type=script&lang=js"

import "./Super.vue?vue&type=style&index=0&id=1edece38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edece38"]])

export default __exports__